import { getAdaptToGridStyles } from './variantStyles/adaptToGrid';
import { getFullWidthStyles } from './variantStyles/fullWidth';
import { getNeutralStyles } from './variantStyles/neutral';
import { getStandardStyles } from './variantStyles/standar';
export const getAccordionSectionStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        ...getNeutralStyles(FOUNDATIONS, FONT, SHADOWS),
        ...getStandardStyles(FOUNDATIONS, FONT, SHADOWS),
        ...getAdaptToGridStyles(FOUNDATIONS, FONT, SHADOWS),
        ...getFullWidthStyles(FOUNDATIONS, FONT, SHADOWS),
    };
};
//# sourceMappingURL=styles.js.map